import {Typography} from '@mui/material';
import {PlanTypeChip} from 'presentation/components';
import {usePersonalData} from 'presentation/hooks';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {formatText} from 'presentation/utils';
import React from 'react';
import {StyledStack} from './styles';

const ChangeBeneficiaryCard = () => {
	const {userName} = usePersonalData();
	const {
		beneficiary: {nmPlano},
	} = useAccountInformation();

	return (
		<StyledStack spacing={0.5}>
			<Typography color="text.primary" variant="label" m={0}>
				{formatText(userName)}
			</Typography>
			<Typography color="text.primary" variant="body1">
				{nmPlano}
			</Typography>
			<PlanTypeChip />
		</StyledStack>
	);
};

export {ChangeBeneficiaryCard};
